import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, QuoteSettings } from '../api';
import { ErrorBox, Field, useAsync } from '../components/ui';

const ROLES: [string, string][] = [['sales', 'értékesítő'], ['owner', 'tulajdonos'], ['support', 'ügyfélszolgálat'], ['finance', 'pénzügy'], ['admin', 'adminisztrátor']];

export function QuoteSettingsPage() {
  const [v, setV] = useState<QuoteSettings | null>(null);
  const [saved, setSaved] = useState(false);
  const a = useAsync();
  useEffect(() => { a.run(async () => setV(await api<QuoteSettings>('/quote-settings'))); }, []);
  if (!v) return a.error ? <ErrorBox error={a.error} /> : <div className="muted">Betöltés…</div>;
  const seller = (k: keyof QuoteSettings['seller']) => (e: { target: { value: string } }) => { setSaved(false); setV({ ...v, seller: { ...v.seller, [k]: e.target.value } }); };
  const save = async () => { if (await a.run(() => api('/quote-settings', { method: 'PUT', body: v }))) setSaved(true); };
  return (
    <div>
      <div className="page-head"><h2>Ajánlat-beállítások</h2><div className="spacer" /><Link to="/ajanlatok">← Ajánlatok</Link></div>
      <div className="cols">
        <section className="card form">
          <h3>Eladó adatai a PDF-en</h3>
          <div className="grid2">
            <Field label="Cégnév"><input value={v.seller.name ?? ''} onChange={seller('name')} /></Field>
            <Field label="Adószám"><input value={v.seller.tax_number ?? ''} onChange={seller('tax_number')} /></Field>
            <Field label="Cím"><input value={v.seller.address ?? ''} onChange={seller('address')} /></Field>
            <Field label="Bankszámla"><input value={v.seller.bank_account ?? ''} onChange={seller('bank_account')} /></Field>
            <Field label="E-mail"><input value={v.seller.email ?? ''} onChange={seller('email')} /></Field>
            <Field label="Telefon"><input value={v.seller.phone ?? ''} onChange={seller('phone')} /></Field>
            <Field label="Weboldal"><input value={v.seller.website ?? ''} onChange={seller('website')} /></Field>
          </div>
          <Field label="Alapértelmezett bevezető szöveg"><textarea rows={2} value={v.intro_default} onChange={(e) => { setSaved(false); setV({ ...v, intro_default: e.target.value }); }} /></Field>
          <Field label="Alapértelmezett feltételek"><textarea rows={4} value={v.terms_default} onChange={(e) => { setSaved(false); setV({ ...v, terms_default: e.target.value }); }} /></Field>
        </section>
        <section className="card form">
          <h3>Sorszám és érvényesség</h3>
          <div className="grid2">
            <Field label="Sorszám-előtag" hint={`pl. ${v.number_prefix}-${new Date().getFullYear()}-0001`}><input value={v.number_prefix} maxLength={8} onChange={(e) => { setSaved(false); setV({ ...v, number_prefix: e.target.value.replace(/[^A-Za-z0-9]/g, '') }); }} /></Field>
            <Field label="Érvényesség (nap)"><input type="number" min={1} max={365} value={v.validity_days} onChange={(e) => { setSaved(false); setV({ ...v, validity_days: Number(e.target.value) }); }} /></Field>
            <Field label="Utánkövetés (nap)" hint="ennyi nap válasz nélkül után emlékeztet; 0 = ki"><input type="number" min={0} max={90} value={v.followup_days ?? 5} onChange={(e) => { setSaved(false); setV({ ...v, followup_days: Number(e.target.value) }); }} /></Field>
          </div>
          <h3>Kedvezménykorlát szerepkörönként</h3>
          <p className="muted small">Ha egy tétel kedvezménye a korlát fölött van, az ajánlat küldés előtt a tulajdonos jóváhagyására vár.</p>
          <div className="grid2">
            {ROLES.map(([r, l]) => (
              <Field key={r} label={`${l} (%)`}><input type="number" min={0} max={100} value={v.max_discount[r] ?? 0}
                onChange={(e) => { setSaved(false); setV({ ...v, max_discount: { ...v.max_discount, [r]: Number(e.target.value) } }); }} /></Field>
            ))}
          </div>
          <ErrorBox error={a.error} />
          <div className="actions"><button onClick={save} disabled={a.busy}>Mentés</button>{saved && <span className="muted small">Elmentve.</span>}</div>
        </section>
      </div>
    </div>
  );
}
